import React from 'react'

const Manual_crear_usuarios_clau_admin = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear usuarios en Clau Admin
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_usuarios_en_Clau_admin__qi1iicxQQi6xCXXxkfJv6Q?as=scrollable"
          className="scribe-iframe-general-67"
          width="100%"
          height="8000"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_crear_usuarios_clau_admin
